import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { registerSW } from 'virtual:pwa-register'

// Register service worker for PWA functionality
const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm('Eine neue Version ist verfügbar. Aktualisieren?')) {
      updateSW()
    }
  },
  onOfflineReady() {
    console.log('App ist bereit für den Offline-Betrieb')
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
